import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import { getEmailAccounts } from 'services/emailAccounts'
import useEmailAccountColumnConfig from '../hooks/useEmailAccountColumnConfig'
import { EMAIL_ACCOUNTS_QUERY_KEY } from '../constants'

const EmailAccountsTable = ({ customerId }) => {
  const { data, isPending: isLoading } = useQuery({
    queryKey: [EMAIL_ACCOUNTS_QUERY_KEY, customerId],
    queryFn: () => getEmailAccounts({ customerId }),
    enabled: !!customerId,
    placeholderData: [],
  })

  const columns = useEmailAccountColumnConfig({ customerId })

  return (
    <DataGrid
      name="customerEmailAccounts"
      pagination={false}
      loading={isLoading}
      columns={columns}
      rows={data}
    />
  )
}

export default EmailAccountsTable
